<template>
<ControlUnit
    :title="$t('control.panel.recognize_user_meta.title')"
    :tooltip="$t('control.panel.recognize_user_meta.tooltip')"
  >
    <label class="input-checkbox">
      <input
        v-model="current_recognize_user_meta"
        type="checkbox"
        class="input-checkbox__input"
      />
      <span>{{ $t('control.panel.recognize_user_meta.label') }}:</span>
    </label>

</ControlUnit>

</template>

<script>
import useStateController from './useStateController';
import ControlUnit from "@/views/Control/ControlPanel/ControlUnit/ControlUnit";
import {useStore} from "vuex";
import {computed, onMounted} from "vue";
import useRouteController from "@/views/Control/ControlPanel/ControlUnit/useRouteController";
import {runAllWithData} from "@/helpers/functional";


export default {
  components: {
    ControlUnit,
  },


  setup() {

    const recognizeUserMeta = 'recognize-user-meta';
    const store = useStore();

    const current_recognize_user_meta = computed({
      get() {
        return store.state.control.recognize_user_meta;
      }, set(val){
          changeHandler({
            type: recognizeUserMeta,
            value: val,
        })
      }
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {

      changeControlHandler({
        type: recognizeUserMeta,
        value: getRouterQueryValue(recognizeUserMeta),
      });
    });

    return {
      recognizeUserMeta,
      current_recognize_user_meta,
      changeHandler,
    };
  },
};
</script>

<style lang="scss" scoped>
.input-checkbox {
  $this: 'input-checkbox';
  font-size: 14px;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  &__input {
    margin-right: 8px;
  }
}
</style>
